import HelpIcon from '@mui/icons-material/Help'
import { Stack, Typography, useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import { formatDate } from 'utils'
import { useAuthContext } from '../../context/AuthProvider'
import Profile from './Profile'
import { useFaq } from './useFaq'

const ProfileInfo = () => {
  const theme = useTheme()
  const { user, isCaregiver, isIndividualTrainee } = useAuthContext()
  const matchesXs = useMediaQuery(theme.breakpoints.down('md'))

  const { onOpenFaq } = useFaq()

  // An individual trainee gets a generated access code, so accessCodeExpiryDate is normally set —
  // the subscription period is the fallback for the window before the code is issued.
  const subscriptionExpiryDate =
    (isCaregiver || isIndividualTrainee) && user?.lastSubscription?.currentPeriodEnd
  const expiryDate = user?.accessCodeExpiryDate || subscriptionExpiryDate

  const info = (
    <Stack direction="column" ml="6px">
      {expiryDate && (
        <Stack direction="row" gap={0.5}>
          <Typography variant="body2">Access expires on </Typography>
          <Typography variant="body2" color="error.main">
            {formatDate(new Date(expiryDate))}
          </Typography>
        </Stack>
      )}
      {user?.trainingPathwayTypeName && (
        <Stack direction="row" gap={0.5}>
          <Typography variant="body2" color="textSecondary">
            Assigned Training Pathway:
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {user?.trainingPathwayTypeName}
          </Typography>
        </Stack>
      )}
    </Stack>
  )

  return (
    <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end', alignItems: 'center' }}>
      <HelpIcon onClick={onOpenFaq} sx={{ cursor: 'pointer' }} />
      {!matchesXs && info}
      <Profile />
    </Box>
  )
}

export default React.memo(ProfileInfo)
